/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Empty"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Sorry."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={12}
 size="large"
 text="We couldn't find what you're looking for."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Do you have the right permissions to access it?"
/>
</div>
{children}
</React.Fragment>)
}